module.exports = __webpack_public_path__ + "static/media/serious_symptoms.2eb7dfb7.svg";